<template>
  <div>
    <app-header><org-nav></org-nav></app-header>
    <section class="container">
      <div class="page-header">
        <h2>Estatísticas da Prova</h2>
      </div>

    </section>
  </div>
</template>

<script>
import AppHeader from '@/pages/layout/Header.vue'
import OrgNav from './Nav.vue'

export default {
  name: 'OrgEstatistica',
  components: {
    AppHeader,
    OrgNav
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// Estatistica.vue?6ec3c622